import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Reset/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import ResetTable from 'components/Web_User_Interface/1440p_Series/System/Reset/resetTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Kamera Reset",
  "path": "/Web_User_Interface/1440p_Serie/System/Werksreset/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Aktivieren Sie die Werksreste-Schaltfläche und bestätigen Sie, um Ihre Kamera auf die Werkseinstellungen zurückzusetzen. Bitte beachten Sie, dass Sie Ihre Kamera wieder neu über ein Netzwerkkabel einrichten müssen, nachdem Sie den Werksreset durchgeführt haben.",
  "image": "./WebUI_1440p_SearchThumb_System_Reset.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_Reset.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menü // Kamera Reset' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Aktivieren Sie die Werksreste-Schaltfläche und bestätigen Sie, um Ihre Kamera auf die Werkseinstellungen zurückzusetzen. Bitte beachten Sie, dass Sie Ihre Kamera wieder neu über ein Netzwerkkabel einrichten müssen, nachdem Sie den Werksreset durchgeführt haben.' image='/images/Search/WebUI_1440p_SearchThumb_System_Reset.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_Reset.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/Reset/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Reset/' crumbLabel="Camera Reset" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/e4a12/1440p_Settings_System_Reset.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.565217391304344%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAB7ElEQVQoz3WSW2sTQRSA8zMsglBKs9lrkSSiTTZpNmlpc9ndmd3N7kabNgWFvinSitJK/4D47OVBxeqj+As/mUmrSPXh45w5DN85zJmK53k4jotZXaPZTwjPfzI8/c7O828Ezy7p/wNVH55ckl38YDQ94s7tW6ysrLC6ukrFtm1s28FYX+N+EDI7+0J++o7piw+kJ+//y+zlRw5ef6Y/muJYFo6zgetuULEsC0XNNGnU71KmEWUaa2ZTwSyLNbqu4lUuJrtM9gYEWwN8v09va5tWq3s9oU2tVqPZvEdRzsiLgrwoKYpSxyTNkEm6RCbsDUeMxxOiKGZ3Z49et0e3E7D5wP8jNAyDRqNBnucURaFReZqmCCF+I6UkiiL29/c5PDxEhAN2Bj06fv+msNlskmWZliRJ8pdICKllGiFIpNR3HhZK2KXjB7RbN4QN5vO5pixLLVYNFImMEdEEEYeEUjKWglhK8nhAf6vDdtDDb7epmKZ5Y0LVWaGEGnUu5shHT0jKBYso5nEYcSAkx0XEdm8pbG22qahlOI5ztZSl8PqtliTIOCI7vqA8/0r59C1vhiGfRjFno4hXi4xsGNDpKKG/nFAJrydVi6nX66gP77qujjp3LFzLwLVNTM/D8DwdG56NZxusrxtUqwa/ABNLdSlQ2BOBAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/fbcedc6ceb711dfd3d6a1ea731693668/e4706/1440p_Settings_System_Reset.avif 230w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/d1af7/1440p_Settings_System_Reset.avif 460w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/7f308/1440p_Settings_System_Reset.avif 920w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/43a10/1440p_Settings_System_Reset.avif 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/fbcedc6ceb711dfd3d6a1ea731693668/a0b58/1440p_Settings_System_Reset.webp 230w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/bc10c/1440p_Settings_System_Reset.webp 460w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/966d8/1440p_Settings_System_Reset.webp 920w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/095e2/1440p_Settings_System_Reset.webp 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/fbcedc6ceb711dfd3d6a1ea731693668/81c8e/1440p_Settings_System_Reset.png 230w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/08a84/1440p_Settings_System_Reset.png 460w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/c0255/1440p_Settings_System_Reset.png 920w", "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/e4a12/1440p_Settings_System_Reset.png 963w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/fbcedc6ceb711dfd3d6a1ea731693668/c0255/1440p_Settings_System_Reset.png",
              "alt": "Web User Interface - 1440p Series - System Reset",
              "title": "Web User Interface - 1440p Series - System Reset",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ResetTable mdxType="ResetTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Da man in den meisten Fällen keinen Zugriff mehr auf die Weboberfläche der Kamera hat, gibt es noch andere Wege die Werkseinstellungen wieder herzustellen:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Aussenkameras/IN-9408_WQHD/Kamera_Reset/"
        }}>{`IN-9408 2k+ (WQHD)`}</a></li>
    </ul>
    <h2 {...{
      "id": "kamera-reset--wps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#kamera-reset--wps",
        "aria-label": "kamera reset  wps permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Kamera Reset & WPS`}</h2>
    <p>{`Wenn Sie die Reset-Taste an Ihrer Kamera drücken, werden die Status-LEDs ausgeschaltet und...`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Nach 3s`}</strong>{`: Schalten sich die Status-LEDs ein und es starten, nach dem Loslassen der Taste, den `}<a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/WLAN/"
        }}>{`Wireless-Protected-Setup`}</a>{` Modus oder `}<strong parentName="li">{`WPS`}</strong>{`, mit dem Sie Ihre Kamera zu Ihrem lokalen WiFi hinzufügen können. Drücken Sie die Taste nocheinmal `}<strong parentName="li">{`für 2s`}</strong>{`, um den Modus vor der regulären 2-minütigen Laufzeit zu beenden.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 15s`}</strong>{`: Beginnen die Status-LEDs langsam zu blinken und es werden, nach dem Loslassen der Taste, alle Kameraeinstellungen `}<strong parentName="li">{`mit Ausnahme der Netzwerkkonfiguration`}</strong>{` zurückgesetzt.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 20s`}</strong>{`: Beginnen die Status-LEDs schnell zu blinken und es werden, nach dem Loslassen der Taste, `}<strong parentName="li">{`ALLE`}</strong>{` Kameraeinstellungen zurückgesetzt.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 30s`}</strong>{`: Gehen die Status-LEDs aus und die Kamera wird in den Zustand vor dem letzten Firmware-Update zurückgesetzt. Anschließend startet die Kamera neu.`}</li>
    </ol>
    {
      /* * [IN-9420 2k+ WQHD Kamera Reset](/Aussenkameras/IN-9420_WQHD/Kamera_Reset/) */
    }
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Aussenkameras/IN-9408_WQHD/Kamera_Reset/"
        }}>{`IN-9408 2k+ WQHD Kamera Reset`}</a>
        {
          /* * [IN-8401 2k+ WQHD Kamera Reset](/Innenkameras/IN-8401_WQHD/Kamera_Reset/) */
        }
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      